// extracted by mini-css-extract-plugin
export default {"darkBackground":"LoadImage_darkBackground__ibxIV","visible":"LoadImage_visible__RRygx","hidden":"LoadImage_hidden__-A7vd"};